import React, { forwardRef } from 'react';
import { VisuallyHidden } from '../../../VisuallyHidden';
import * as S from './Button.styles';
export const Button = forwardRef((props, ref) => React.createElement(S.Button, Object.assign({
  "data-ds-component": "DS-Dropdown-Button"
}, props, {
  ref: ref,
  type: "button"
}), React.createElement(VisuallyHidden, null, props.isOpen ? 'Fechar' : 'Mostrar', " op\u00E7\u00F5es"), props.children));
Button.displayName = 'Button';